/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Locations API
 * AV Services Locations management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  SpacesControllerV2FindAllV2200,
  SpacesControllerV2FindAllV2Params,
  SpacesControllerV2FindAllV2PathParameters,
  SpacesControllerV2FindOneV2200,
  SpacesControllerV2FindOneV2PathParameters,
} from '../models';

@Injectable({ providedIn: 'root' })
export class SpacesV2Service {
  private readonly http = inject(HttpClient);
  /**
   * Returns spaces across all locations for the client.
   * @summary Retrieve all spaces for a client
   */

  findAll<TData = SpacesControllerV2FindAllV2200>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: SpacesControllerV2FindAllV2PathParameters,
    params?: SpacesControllerV2FindAllV2Params,
  ): Observable<TData> {
    return this.http.get<TData>(`/locations/v2/clients/${clientId}/spaces`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
  /**
   * @summary Retrieve a specific space for a client
   */

  findOne<TData = SpacesControllerV2FindOneV2200>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    spaceId,
  }: SpacesControllerV2FindOneV2PathParameters): Observable<TData> {
    return this.http.get<TData>(`/locations/v2/clients/${clientId}/spaces/${spaceId}`);
  }
}
